import React from 'react';

import { Typography } from '@eGroupTeam/material';

const DisplayField = ({ label, ...other }) => (
  <Typography {...other}>{label}</Typography>
);

export default DisplayField;
